import React, { useEffect, useState } from 'react';
import CustomInput from '../../../components/customInput';
import API from '../../../services/api';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../../redux/dashboard/actions';
import DeletePortalModal from '../modal/deletePortalModal';
import CustomTextArea from '../../../components/customTextArea';
import utils from '../../../utils';

const PortalInfo = ({ portal, reloadCallback, isCreateMode, onChange }) => {
  const [displayName, setDisplayName] = useState(portal?.displayName || '');
  const [description, setDescription] = useState(portal?.description || '');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState(portal?.errors || {});

  const dispatch = useDispatch();

  useEffect(() => {
    setDisplayName(portal?.displayName || '');
    setDescription(portal?.description || '');
  }, [portal]);

  useEffect(() => {
    const validation = {
      'portal-display-name': [
        { key: 'required', value: true },
        { key: 'min', value: 4 }
      ]
    };

    const errorList = {
      'portal-display-name': utils.fieldValidation(displayName, validation['portal-display-name']).join(', ')
    };
    setErrors(errorList);
    onChange && onChange({ ...portal, errors: { ...portal.errors, ...errorList }, displayName: displayName });
  }, [displayName]);

  useEffect(() => {
    onChange && onChange({ ...portal, description });
  }, [description]);

  const handlePortalDelete = portalId => {
    API.deletePortal(portalId)
      .then(() => {
        dispatch(setAlert({ type: 'success', message: 'Portal deleted successfully!' }));
        reloadCallback();
      })
      .catch(error => {
        dispatch(setAlert({ type: 'danger', message: `Error deleting portal: ${error.message}` }));
      })
      .finally(() => {
        setIsModalOpen(false);
      });
  };

  if (isCreateMode) {
    return (
      <div className="portal-info">
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Portal Name</label>
              <CustomInput
                label="Portal Name"
                type="text"
                value={displayName}
                onChange={e => setDisplayName(e.target.value)}
                isEditable={true}
                errorMessage={errors['portal-display-name']}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Description</label>
              <CustomTextArea
                id={`portal-description-${portal?.displayName || 'new'}`}
                value={description || ''}
                onChange={e => setDescription(e.target.value)}
                isEditable={true}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="portal-info">
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Portal Name</label>
              <CustomInput
                label="Portal Name"
                type="text"
                value={displayName}
                onChange={e => setDisplayName(e.target.value)}
                isEditable={true}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Description</label>
              <CustomInput
                label="Description"
                type="text"
                value={description}
                onChange={e => setDescription(e.target.value)}
                isEditable={true}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Id</label>
              <CustomInput label="Id" type="text" value={portal?.id || ''} isEditable={false} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Created At</label>
              <CustomInput
                label="Created At"
                type="text"
                value={new Date(portal?.createTime).toLocaleString()}
                isEditable={false}
              />
            </div>
          </div>
        </div>
        {isModalOpen && (
          <DeletePortalModal
            isOpen={isModalOpen}
            cancelCb={() => setIsModalOpen(false)}
            confirmCb={() => handlePortalDelete(portal.id)}
          />
        )}
      </div>
    </>
  );
};

export default PortalInfo;
